import { render, staticRenderFns } from "./InvestmentShow.vue?vue&type=template&id=56ce0990&scoped=true"
import script from "./InvestmentShow.vue?vue&type=script&lang=js"
export * from "./InvestmentShow.vue?vue&type=script&lang=js"
import style0 from "../fta.css?vue&type=style&index=0&id=56ce0990&prod&scoped=true&lang=css&external"
import style1 from "./InvestmentShow.less?vue&type=style&index=1&id=56ce0990&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ce0990",
  null
  
)

export default component.exports